<template>
  <component :is="tag"
             :type="nativeType"
             :disabled="loading || disabled"
             @click="handleClick"
             class="btn"
             :class="classes">
    <span class="btn-label" v-if="$slots.label || loading">
      <slot name="label" v-if="!loading"></slot>
      <i v-if="loading" class="fas fa-spinner fa-spin"></i>
    </span>
    <slot></slot>
    <span class="btn-label btn-label-right" v-if="$slots.labelRight">
      <slot name="labelRight"></slot>
    </span>
  </component>
</template>
<script>
  export default {
    name: 'base-button',
    props: {
      tag: {
        type: String,
        default: 'button',
        description: 'Html tag to use'
      },
      type: {
        type: String,
        default: 'default',
        description: 'Color type'
      },
      nativeType: {
        type: String,
        default: 'button',
        description: 'Native button type (e.g submit|button) '
      },
      round: Boolean,
      outline: Boolean,
      block: Boolean,
      social: Boolean,
      loading: Boolean,
      disabled: Boolean,
      link: Boolean,
      icon: Boolean,
      wide: Boolean,
      size: String
    },
    computed: {
      classes() {
        let btnClasses = [
          {[`btn-outline-${this.type} btn-outline`]: this.outline},
          {'btn-icon': this.icon},
          {'btn-round': this.round},
          {'btn-block': this.block},
          {'btn-social': this.social},
          {'btn-link': this.link},
          {'btn-wd': this.wide},
          `btn-${this.type}`
        ];
        if (this.size) {
          btnClasses.push(`btn-${this.size}`)
        }
        return btnClasses
      }
    },
    methods: {
      handleClick(evt) {
        this.$emit('click', evt)
      }
    }
  }
</script>
<style>
</style>
